import { useContext } from 'react';
import { SendDocumentsJobContext } from './context';

export default function useSendDocumentsJobContext() {
  return useContext(SendDocumentsJobContext);
}
